<template>
  <GlassCard class="col-md-2 mb-3 py-3">
    <div class="col-sm-12 col-md-12 h-100 m-0 p-0">
      <!-- Form -->
      <component :is="activeComponent" @component="activeComponent = $event" />
    </div>
  </GlassCard>
</template>

<script>
/* Components */
import Inicio from './Inicio'
import MsgCompleto from './MsgCompleto'

/* State */
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'NovaSenha',
  components: {
    Inicio,
    MsgCompleto,
  },
  data: () => ({
    activeComponent: 'Inicio',
  }),
  computed: {
    ...mapGetters(['cardLogoWidth']),
    ...mapState(['template', 'config', 'subdomain']),
  },
}
</script>

<style>
.fontPersonalizada {
  font-size: 16px;
  line-height: 19px;
}

.fontMenor {
  font-size: 12px;
}

.btnStock {
  background-color: #e6c156;
  border-color: #e6c156;
  color: black;
}

.btn {
  height: 48px;
}

.c-errors {
  border: gray 1px solid;
  background: rgba(20, 20, 20, 0.1);
}
</style>
